/* eslint-disable array-callback-return */
import React, { useState } from 'react';
//import PlayerCard from './PlayerCard';

const useSortableData = (items, config = null) => {
    const [sortConfig, setSortConfig] = React.useState(config);
    const sortedItems = React.useMemo(() => {
        let sortableItems = [...items];
        if (sortConfig !== null) {
            sortableItems.sort((a, b) => {
                if (a[sortConfig.key] < b[sortConfig.key]) {
                return sortConfig.direction === 'ascending' ? -1 : 1;
                }
                if (a[sortConfig.key] > b[sortConfig.key]) {
                return sortConfig.direction === 'ascending' ? 1 : -1;
                }
                return 0;
            });
        }
        return sortableItems;
    }, [items, sortConfig]);

    const requestSort = key => {
        let direction = 'ascending';
        if (sortConfig && sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    }

    return { items: sortedItems, requestSort, sortConfig };
}

const StatsTable = (props) => {
    const [filterString, setFilterString] = useState('');
    const players = props.players;

    const { items, requestSort, sortConfig } = useSortableData(players);
    const getClassNamesFor = (name) => {
        if (!sortConfig) {
            return;
        }
        return sortConfig.key === name ? sortConfig.direction : undefined;
    };

    const handleSearch = (e) => {
        var terms = e.target.value.toLowerCase();
        setFilterString(terms);
    }
    
    const statsList = items.filter(player => player.school.toLowerCase().includes(filterString)).map((player, index)=>{
        var fname = player.player.split(",")[1].trim();
        var lname = player.player.split(",")[0].trim();
        var name = `${fname} ${lname}`;
        var rowClass = index === 0 || index % 2 === 0 ? 'odd' : 'even';
        //className="sorting_1"
        
        return  (
            <tr key={player.pid + '_item_' + index} className={rowClass}>
                <td>{player.pid}</td>
                <td>{name}</td>
                <td>{player.seed}</td>
                <td>{player.school}</td>
                <td>{player.pts}</td>
                <td>{player.fg}</td>
                <td>{player["3p"]}</td>
                <td>{player.ft}</td>
            </tr>
        )
    })

    return  (
        
        <div id="stats-popup-table_wrapper" className="dataTables_wrapper no-footer" ><div id="stats-popup-table_filter" className="dataTables_filter">
            <label>Search by school: <input type="search" className="search-school" value={filterString} onChange={e=> handleSearch(e)}/></label>
            </div>
            <table id="stats-popup-table" className="dataTable no-footer" role="grid" aria-describedby="stats-popup-table_info">
                <thead>
                    <tr role="row">
                        <th><span type="button" onClick={() => requestSort('pid')} className={getClassNamesFor('pid')}>Rank</span></th>
                        <th><span type="button" onClick={() => requestSort('player')} className={getClassNamesFor('player')}>Player</span></th>
                        <th><span type="button" onClick={() => requestSort('seed')} className={getClassNamesFor('seed')}>Seed</span></th>
                        <th><span type="button" onClick={() => requestSort('school')} className={getClassNamesFor('school')}>School</span></th>
                        <th><span type="button" onClick={() => requestSort('pts')} className={getClassNamesFor('pts')}>PPG</span></th>
                        <th><span type="button" onClick={() => requestSort('fg')} className={getClassNamesFor('fg')}>FG%</span></th>
                        <th><span type="button" onClick={() => requestSort('3p')} className={getClassNamesFor('3p')}>3P%</span></th>
                        <th><span type="button" onClick={() => requestSort('ft')} className={getClassNamesFor('ft')}>FT%</span></th>
                    </tr>
                </thead>
                <tbody>
                    {statsList}
                </tbody>
            </table>
        </div>
    )
};

export default StatsTable;